export default __webpack_public_path__ + "static/writing-en@2x-0a9fa63966942d70d7ecbc1f432ae896.png";